module.exports = __webpack_public_path__ + "assets/img/dzh-3.d5f745a1.jpg";